import { render, staticRenderFns } from "./manage-billing.vue?vue&type=template&id=67698bfc&scoped=true"
import script from "./manage-billing.vue?vue&type=script&lang=js"
export * from "./manage-billing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67698bfc",
  null
  
)

export default component.exports